/**
 * String Constants
 */
export const TOKENS = "tokens";
export const USER = "user";

// For Navbar
export const MENU_ITEMS_APP = [
  {
    title: "Agents",
    path: "/",
    alternatePath: "/agents/new",
    muiIcon: "SmartToyOutlined",
  },
  {
    title: "Business Units",
    path: "/business-units",
    muiIcon: "Inventory2Outlined",
  },
  {
    title: "Reports",
    path: "/admin-downloads",
    muiIcon: "BarChartOutlined",
  },
  {
    title: "Access Control",
    path: "/access-control",
    muiIcon: "LockOutlined",
  },
  {
    title: "Debug Logs",
    path: "/debug-logs",
    muiIcon: "BugReportOutlined",
  },
  {
    title: "Settings",
    path: "/manage",
    muiIcon: "SettingsOutlined",
  },
];

// Legacy app-level nav items (pre-alpha) — kept for backward compat with old routes
export const MENU_ITEMS_APP_LEGACY = [
  {
    title: "Knowledge Base",
    muiIcon: "MenuBookOutlined",
    children: [
      {
        title: "Smart Probing",
        path: "/knowledge-store/smart-probing",
        muiIcon: "SearchOutlined",
      },
      {
        title: "Program Data Model",
        path: "/knowledge-store/program-data-model",
        muiIcon: "AccountTreeOutlined",
      },
    ],
  },
  {
    title: "User Profiling",
    muiIcon: "PersonOutlined",
    children: [
      {
        title: "Manage User Profile",
        path: "/user-profiling/user-profile-data-model",
        muiIcon: "PersonOutlined",
      },
      {
        title: "InSync User profile",
        path: "/user_profiles",
        redirect: true,
        muiIcon: "PersonOutlined",
      },
    ],
  },
  {
    title: "Controls",
    muiIcon: "TuneOutlined",
    children: [
      {
        title: "AI Personality",
        path: "/controls/ai-personality",
        muiIcon: "PsychologyOutlined",
      },
      {
        title: "Business Context",
        path: "/controls/business-context",
        muiIcon: "BusinessOutlined",
      },
      {
        title: "Sensitive Topics",
        path: "/controls/sensitive-topics",
        muiIcon: "WarningAmberOutlined",
      },
      {
        title: "No-GO Topics",
        path: "/controls/no-go-topics",
        muiIcon: "BlockOutlined",
      },
      {
        title: "Url Weightage",
        path: "/controls/url-weightage",
        muiIcon: "TuneOutlined",
      },
    ],
  },
  { title: "Integrations", path: "/integrations", icon: "integrations" },
  { title: "Appearance", path: "/appearance", icon: "appearance" },
  { title: "AI Testing", path: "/bot-testing", icon: "bot-testing" },
  {
    title: "Business Insights",
    redirect: true,
    path: "/dashboard",
    muiIcon: "BarChartOutlined",
  },
  {
    title: "Personalization",
    muiIcon: "SchoolOutlined",
    children: [
      {
        title: "Manage User Profile",
        path: "/personalization/user-profile-data-model",
        muiIcon: "SchoolOutlined",
      },
      {
        title: "Manage Program Profile",
        path: "/personalization/program-profile-data-model",
        muiIcon: "SchoolOutlined",
      },
    ],
  },
];

export const MENU_ITEMS_ADMIN = [
  {
    title: "Clients",
    path: "/clients",
    alternatePath: "/",
    muiIcon: "DashboardOutlined",
  },
  {
    title: "Agent Store",
    path: "/admin/agent-templates",
    muiIcon: "DescriptionOutlined",
  },
  {
    title: "Agent Variables",
    path: "/admin/agent-variables",
    muiIcon: "ArticleOutlined",
  },
  {
    title: "Capabilities Store",
    path: "/admin/capabilities",
    muiIcon: "StorageOutlined",
  },
  {
    title: "AI Models",
    muiIcon: "ScienceOutlined",
    children: [
      {
        title: "Intent Models",
        path: "/admin/ai-models/intent-models",
        muiIcon: "ScienceOutlined",
      },
    ],
  },
  {
    title: "System",
    muiIcon: "TuneOutlined",
    divider: true,
    children: [
      {
        title: "Users & Control",
        path: "/admin/users",
        alternatePath: "/users",
        muiIcon: "PeopleOutlined",
      },
      {
        title: "Billing",
        path: "/admin/billing",
        muiIcon: "CreditCardOutlined",
      },
      {
        title: "System Status",
        path: "/admin/system-status",
        muiIcon: "DnsOutlined",
      },
    ],
  },
];

export const MENU_ITEMS_AGENT = [
  // ── Configure ──────────────────────────────────────────
  {
    title: "Agent Profile",
    path: "/profile",
    muiIcon: "SettingsOutlined",
  },
  {
    title: "Prompt Variables",
    path: "/instructions",
    muiIcon: "DescriptionOutlined",
  },
  {
    title: "System Prompt",
    path: "/prompt",
    muiIcon: "ArticleOutlined",
  },
  // ── Knowledge ──────────────────────────────────────────
  {
    title: "Knowledge Base",
    muiIcon: "MenuBookOutlined",
    children: [
      {
        title: "Websites",
        path: "/knowledge-bases/websites",
        muiIcon: "LanguageOutlined",
      },
      {
        title: "Files",
        path: "/knowledge-bases/files",
        muiIcon: "FolderOutlined",
      },
    ],
  },
  {
    title: "Personalization",
    muiIcon: "SchoolOutlined",
    children: [
      {
        title: "User Profile",
        path: "/personalization/user-profile-data-model",
        muiIcon: "PersonOutlined",
      },
      {
        title: "Program Profile",
        path: "/personalization/program-profile-data-model",
        muiIcon: "AccountTreeOutlined",
      },
    ],
  },
  // ── Capabilities ───────────────────────────────────────
  {
    title: "Capabilities",
    path: "/capabilities",
    muiIcon: "BoltOutlined",
  },
  // ── Controls ───────────────────────────────────────────
  {
    title: "Controls",
    muiIcon: "TuneOutlined",
    children: [
      {
        title: "AI Personality",
        path: "/controls/ai-personality",
        muiIcon: "PsychologyOutlined",
      },
      {
        title: "Business Context",
        path: "/controls/business-context",
        muiIcon: "BusinessOutlined",
      },
      {
        title: "Smart Probing",
        path: "/knowledge-bases/smart-probing",
        muiIcon: "SearchOutlined",
      },
      {
        title: "Sensitive Topics",
        path: "/controls/sensitive-topics",
        muiIcon: "WarningAmberOutlined",
      },
      {
        title: "No-GO Topics",
        path: "/controls/no-go-topics",
        muiIcon: "BlockOutlined",
      },
      {
        title: "URL Weightage",
        path: "/controls/url-weightage",
        muiIcon: "TuneOutlined",
      },
    ],
  },
  // ── Deploy ─────────────────────────────────────────────
  {
    title: "Channels",
    path: "/channels",
    muiIcon: "TimelineOutlined",
  },
  {
    title: "Appearance",
    path: "/settings/appearance",
    muiIcon: "PaletteOutlined",
  },
  // ── Test & Monitor ─────────────────────────────────────
  {
    title: "Test AI Agent",
    path: "/settings/bot-testing",
    muiIcon: "TerminalOutlined",
  },
  {
    title: "User Profiling",
    muiIcon: "PersonOutlined",
    children: [
      {
        title: "InSync User Profile",
        path: "/user_profiles",
        redirect: true,
        muiIcon: "ManageAccountsOutlined",
      },
    ],
  },
  {
    title: "Insights",
    path: "/insights/user-profile",
    redirect: true,
    muiIcon: "BarChartOutlined",
  },
];

export const TEST_AI_AGENT_LABEL = MENU_ITEMS_AGENT.find(
  (item) => item.path === "/settings/bot-testing"
)?.title;

export const PUSH_TO_DEV_LABEL = "Push to Dev";

/**
 * Labels
 */
export const GENERIC_LABELM_FONT_SIZE = "14px";
export const GENERIC_LABEL_L_FONT_SIZE = "16px";
export const GENERIC_BUTTON_FONT_SIZE = "18px";
export const GENERIC_BUTTON_HEIGHT = "42px";
export const GENERIC_PAGE_HEADER_FONT_SIZE = "32px";
export const GENERIC_PAGE_SUB_HEADER_FONT_SIZE = "28px";
export const GENERIC_SUBTITLEM_FONT_SIZE = "20px";
export const GENERIC_SUBTITLES_FONT_SIZE = "14px";
export const GENERIC_CAPTIONM_FONT_SIZE = "18px";
export const GENERIC_CAPTIONS_FONT_SIZE = "16px";
export const GENERIC_EDIT_FIELD_FONT_SIZE = "14px";
export const GENERIC_EDIT_PLACEHORDER_FONT_SIZE = "14px";

/**
 * CONFIGS
 */
export const USER_ROLES = [
  { title: "User", value: "user" },
  { title: "Admin", value: "admin" },
  { title: "System Admin", value: "super_admin" },
];

export const APP_USER_ROLES = [
  { title: "Client", value: "client_user" },
  { title: "Client Admin", value: "client_admin" },
  //   { title: "Editor", value: "editor" },
  { title: "Admin", value: "admin" },
  { title: "Super Admin", value: "super_admin" },
];

export const APPEARANCE_IMAGE_UPLOAD_ENDPOINT = "/v1/appearances/upload_file";
export const APPEARANCE_GET_ENDPOINT = "/v1/appearances";
export const APPEARANCE_UPDATE_ENDPOINT = "/v1/appearances";
export const APPEARANCE_PROD_DIFF_ENDPOINT = "/v1/appearances/get_diff";

export const FILES_GET_ENDPOINT = "/v1/files";
export const FILES_PRESIGNED_URL_ENDPOINT = "/v1/files/presigned_urls";
export const FILES_COMPLETE_UPLOAD_ENDPOINT = "/v1/files/complete_upload";
export const FILES_CLOUDFRONT_BASE_URL =
  "https://d2iehqn4soud5r.cloudfront.net";

export const SDK_LOGO_CLOUDFRONT_BASE_URL =
  "https://d2c0xhqyhmtkod.cloudfront.net";

export const PLACEHOLDER_LOGO_URL_S3 = "/image (2).png";

export const ACCEPTED_LOGO_FORMATS = ".svg,.png,.jpg,.jpeg,.webp,.gif";

export const LANGUAGES = [
  { label: "English", value: "English" },
  { label: "Spanish", value: "Spanish" },
  { label: "French", value: "French" },
  { label: "German", value: "German" },
];

export const TIMEZONES = [
  { label: "Pacific Time (PT)", value: "Pacific Time (PT)" },
  { label: "Mountain Time (MT)", value: "Mountain Time (MT)" },
  { label: "Central Time (CT)", value: "Central Time (CT)" },
  { label: "Eastern Time (ET)", value: "Eastern Time (ET)" },
  { label: "Greenwich Mean Time (GMT)", value: "Greenwich Mean Time (GMT)" },
  {
    label: "Central European Time (CET)",
    value: "Central European Time (CET)",
  },
  { label: "Indian Standard Time (IST)", value: "Indian Standard Time (IST)" },
  { label: "China Standard Time (CST)", value: "China Standard Time (CST)" },
  { label: "Japan Standard Time (JST)", value: "Japan Standard Time (JST)" },
  {
    label: "Australian Eastern Time (AET)",
    value: "Australian Eastern Time (AET)",
  },
  { label: "Hawaii-Aleutian Time (HST)", value: "Hawaii-Aleutian Time (HST)" },
];

export const AGENT_WORKFLOW_TYPES = [
  { label: "LLM Agent (Single AI)", value: "llm_agent" },
  { label: "Sequential Agent (Step-by-step)", value: "sequential_agent" },
  { label: "Parallel Agent (Concurrent tasks)", value: "parallel_agent" },
  { label: "Loop Agent (Iterative)", value: "loop_agent" },
];

// Business/functional profile of an agent. Kept in sync with the agent_type
// enum in configurator-api/app/models/agent.rb — a value offered here that is
// missing there is rejected on save. `categories` drives the grouping in the
// Agent Store; content_gap_agent applies to both.
export const AGENT_PROFILE_TYPES = [
  {
    emoji: "\u{1F680}",
    label: "Enrollment AI",
    description:
      "Turn inquiries into enrollments with automated guidance across the full admissions journey.",
    value: "enrollment",
    categories: ["higher_ed"],
  },
  {
    emoji: "\u{1F3C5}",
    label: "Student Success AI",
    description:
      "Support enrolled students over chat inside the LMS, from course questions to progress checks.",
    value: "student_success",
    categories: ["higher_ed"],
  },
  {
    emoji: "\u26A0\uFE0F",
    label: "Student Risk & Notifications",
    description:
      "Identify students at risk early and drive intervention through targeted outreach.",
    value: "student_risk_and_notifications",
    categories: ["higher_ed"],
  },
  {
    emoji: "\u{1F504}",
    label: "Transfer Student Review",
    description:
      "Review transfer applications against institutional policy and produce structured advisor recommendations.",
    value: "transfer_student_review_agent",
    categories: ["higher_ed"],
  },
  {
    emoji: "\u{1F464}",
    label: "User Profiling",
    description:
      "Build a deep student profile from conversations and connected systems.",
    value: "user_profiling_agent",
    categories: ["higher_ed"],
  },
  {
    emoji: "\u{1F4CB}",
    label: "Program Recommendation",
    description:
      "Guide students through complex course catalogs and degree requirements with personalized recommendations.",
    value: "program_recommendation",
    categories: ["higher_ed"],
  },
  {
    emoji: "\u{1F50D}",
    label: "Content Gap",
    description:
      "Surface the questions your content cannot answer yet, so the gaps can be filled.",
    value: "content_gap_agent",
    categories: ["higher_ed", "ecommerce"],
  },
  {
    emoji: "\u{1F3A7}",
    label: "Customer Support",
    description:
      "Handle policies, orders, returns, and agent handoff for online stores.",
    value: "customer_support",
    categories: ["ecommerce"],
  },
  {
    emoji: "\u2699\uFE0F",
    label: "Build Your Agent",
    description:
      "Build a custom agent from scratch with your own specific requirements.",
    value: "general",
    categories: ["general"],
  },
];

// value = base market to copy from; agent_type drives the chat_ai config
// downstream; client_type is the App enum (higher_ed / ecommerce).
export const CLIENT_TYPES = [
  { title: "Higher Edu - Enroll", value: "us_eduenroll", agent_type: "HigherEdEnroll", client_type: "higher_ed" },
  { title: "Higher Edu - Engage", value: "us_eduengage", agent_type: "HigherEdRetain", client_type: "higher_ed" },
  { title: "Ecommerce", value: "us_ecommerce", agent_type: "Ecommerce", client_type: "ecommerce" },
];

export const REFRESH_INPUT_STYLE = {
  width: "130px",
  maxHeight: "50px",
  height: "26px",
  minHeight: "26px !important",
  margin: "0px",
  "& input": {
    padding: "10px 20px 10px 0px !important",
    border: "none",
    minHeight: "26px !important",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px 10px 10px 10px",
    border: "1px solid #9DA6B6",
    paddingLeft: "20px",
    minHeight: "24px !important",
  },
};

export const SEARCH_STYLE = {
  width: "300px",
  maxHeight: "50px",
  height: "48px",
  minHeight: "48px !important",
  margin: "0px",
  "& input": {
    padding: "10px 20px 10px 0px !important",
    border: "none",
    minHeight: "48px !important",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px 10px 10px 10px",
    border: "1px solid #9DA6B6",
    paddingLeft: "20px",
    minHeight: "46px !important",
  },
};

// Website links statuses used for filtering
export const WEBSITE_FILTER_OPTIONS = [
  "pending_review",
  "pending_sitemap_generation",
  "sitemap_generated",
  "to_be_indexed",
  "sent_for_indexing",
  "indexed",
  "to_be_skipped",
  "sent_for_skipping",
  "skipped",
  "to_be_deleted",
  "sent_for_deletion",
  "deleted",
  "failed_to_index",
  "failed_to_delete",
  "failed_to_skip",
  "failed_to_index",
];

// Status of the urls after sitemap refresh job to review
export const SITEMAP_REFRESH_REVIEW_STATUS = ["add", "delete"];

// Countries code for creating clients
export const COUNTRIES = [
  { label: "Select", value: "" },
  { label: "United States Of America (US)", value: "US" },
  { label: "United Kingdom (UK)", value: "UK" },
  { label: "Europe (EU)", value: "EU" },
  { label: "India (IN)", value: "IN" },
];

export const MODE_ENVS = [
  { label: "Sandbox", value: "staging" },
  { label: "Production", value: "production" },
];

// Data Model Group options
export const DATA_MODEL_GROUPS = [
  {
    title: "Academic Profile",
    value: "Academic Profile",
  },
  {
    title: "Professional Profile",
    value: "Professional Profile",
  },
  {
    title: "Learning Interests",
    value: "Learning Interests",
  },
  {
    title: "Program Structure",
    value: "Program Structure",
  },
  {
    title: "Program Content & Descriptions",
    value: "Program Content & Descriptions",
  },
  {
    title: "Program Eligibility Requirements",
    value: "Program Eligibility Requirements",
  },
  {
    title: "Personal Contact Information",
    value: "Personal Contact Information",
  },
  {
    title: "Academic & Partnership Details",
    value: "Academic & Partnership Details",
  },
  {
    title: "Scheduling & Duration",
    value: "Scheduling & Duration",
  },
  {
    title: "Budgets & Financials",
    value: "Budgets & Financials",
  },
  {
    title: "Career & Skill Maps",
    value: "Career & Skill Maps",
  },
  {
    title: "Residency & Visa",
    value: "Residency & Visa",
  },
  {
    title: "Communication Preferences",
    value: "Communication Preferences",
  },
  {
    title: "Engagement History",
    value: "Engagement History",
  },
  {
    title: "Enrollment/Application History",
    value: "Enrollment/Application History",
  },
  {
    title: "Others",
    value: "Others",
  },
];
